import React from 'react'
import { ActivityIndicator, ScrollView } from 'react-native'

import { Button } from '@zet/design-system/button'
import { Stack, XStack } from '@zet/design-system/layout'
import { BTN } from '@zet/design-system/typography'
import { useUserContext } from '@zet/feature-user'
import { DEVICE_HEIGHT } from '@zet/utils/Constants'

import { useLogout } from '@hooks/useLogout'

import { useShowPayoutEarnings } from '../../api/earnings/hooks'
import EarningWidgetContainer from '../../components/homeScreen/earningsWidget'
import Footer from '../../components/homeScreen/footer'
import { i18n } from '../../localization'
import Power from '../../svg/Power'
import HelpAndSupport from './helpAndSupport'
import MyProfile from './myProfile'
import ProfilePicture from './profilePicture'
import UserIdCard from './userIdCard'

const AccountDetails = () => {
  const { data: showPayout } = useShowPayoutEarnings()

  const { data, isLoading } = useUserContext()

  const { logout } = useLogout()

  if (isLoading) {
    return (
      <Stack
        className="flex-1 items-center justify-center"
        style={{ height: DEVICE_HEIGHT - 400 }}
      >
        <ActivityIndicator />
      </Stack>
    )
  }
  return (
    <Stack className="bg-neutral-white100 flex-1">
      <ScrollView>
        <ProfilePicture data={data} />

        {/* ID Card */}
        <UserIdCard />
        {showPayout && <EarningWidgetContainer isProfileScreen />}

        <MyProfile data={data} />

        <HelpAndSupport />

        <Stack className=" border-grays-30 border-t-2 px-3">
          <Button
            size={'lg'}
            outlined
            intent={'error'}
            className=" m-5 self-center"
            onPress={logout}
          >
            <XStack className="items-center justify-center">
              <Power />
              <BTN className="ml-2 text-red-500">
                {i18n.t('myAccount.logout')}
              </BTN>
            </XStack>
          </Button>
        </Stack>

        <Footer position="center" />
      </ScrollView>
    </Stack>
  )
}

export default AccountDetails
